<template>
  <div class="py-4 container-fluid">
    <div class="pb-4">
      <div class="row" id="step1">
        <div class="col-xl-3 col-sm-6 mb-xl-0">
          <mini-statistics-card
            title="총 생산된 제품 수"
            :value="totalProduced + totalShipped"
            :icon="{
              component: 'ni ni-box-2',
              background: iconBackground,
            }"
            direction-reverse
          />
        </div>
        <div class="col-xl-3 col-sm-6 mb-xl-0">
          <mini-statistics-card
            title="총 출하된 제품 수"
            :value="totalShipped"
            :icon="{
              component: 'ni ni-send',
              background: iconBackground,
            }"
            direction-reverse
          />
        </div>
        <div class="col-xl-3 col-sm-6 mb-xl-0">
          <mini-statistics-card
            title="현재 유통 중인 제품 수"
            :value="totalInTransit"
            :icon="{
              component: 'ni ni-world ',
              background: iconBackground,
            }"
            direction-reverse
          />
        </div>
        <div class="col-xl-3 col-sm-6 mb-xl-0">
          <mini-statistics-card
            title="소매점에 도달한 제품 수"
            :value="totalArrivedRetail"
            :icon="{
              component: 'ni ni-shop',
              background: iconBackground,
            }"
            direction-reverse
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-5 mb-lg-0">
        <div class="card z-index-2" id="step2">
          <div class="p-4 pb-0 card-header">
            <h6 class="mb-1">이벤트 발생수</h6>
            <p class="text-sm mb-1">생산/제조/유통 과정의 모든 이벤트가 포함됩니다.</p>
          </div>
          <div class="p-3 card-body">
            <reports-bar-chart
              :stats="{
                todayCount: todayCount,
                dailyCounts: dailyCounts
              }"
              :items="[
                {
                  icon: { color: 'primary', component: 'ni ni-building' },
                  label: '업무장소',
                  progress: { content: blCount, percentage: 100 },
                },
                {
                  icon: { color: 'info', component: 'ni ni-pin-3' },
                  label: '스캔장소',
                  progress: { content: rpCount, percentage: 100 },
                },
                {
                  icon: { color: 'warning', component: 'ni ni-box-2' },
                  label: '재료',
                  progress: { content: rmCount, percentage: 100 },
                },
                {
                  icon: { color: 'danger', component: 'ni ni-settings' },
                  label: '제품',
                  progress: { content: pdCount, percentage: 100 },
                },
              ]"
            />
          </div>
        </div>
      </div>
      <div class="col-lg-7">
        <div class="card z-index-2 h-100" id="step3">
          <gradient-line-chart
            :key="chartKey"
            id="chart-line"
            title="QR 조회수"
            :chart="chartData"
          />
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <div class="card pb-3" id="step4">
          <div class="p-4 pb-0 card-header d-flex align-items-center justify-content-between">
            <div>
              <h6 class="mb-1">제품 목록</h6>
              <p class="text-sm mb-1">등록 된 제품의 목록을 조회합니다.</p>
            </div>
            <RouterLink
              class="text-secondary m-2 mt-0 icon-move-right"
              :to="{ name: 'Products' }"
            >
            <i class="fas fa-arrow-right text-sm" aria-hidden="true"></i>
            </RouterLink>
          </div>
          <div class="p-3 card-body">
            <div class="row">
              <default-project-card
                v-for="product in sampleProductList"
                :key="product.id"
                :title="product.name"
                :image="product.imageUrl"
                :label="`GTIN: ${product.gtin}`"
                :description="`제조사: ${product.manufacturer}`"
                :action="{
                  route: `/products/${product.id}`,
                  color: 'success',
                  label: '상세보기'
                }"
              />
              <div class="mb-4 col-xl-3 col-md-6 mb-xl-0 d-flex">
                <div class="w-100">
                  <place-holder-card
                    :title="{ text: '제품 등록', variant: 'h5' }"
                    :route="'/products/new'"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    
    <div class="row my-4">
      <div class="col-12">
        <div class="mb-4 card pb-3" id="step5">
          <div class="p-4 pb-0 card-header d-flex align-items-center justify-content-between">
            <div>
              <h6 class="mb-1">최근 이벤트</h6>
              <p class="text-sm mb-1">발생한 EPCIS 이벤트를 최신순으로 조회합니다.</p>
            </div>
            <RouterLink
              class="text-secondary m-2 mt-0 icon-move-right"
              :to="{ name: 'EventList' }"
            >
            <i class="fas fa-arrow-right text-sm" aria-hidden="true"></i>
            </RouterLink>
          </div>
          <div class="p-3 card-body">
            <event-list 
              :filters="form" 
              :applyTick="applyTick"
              :initPageSize="5"
              :heights="{
                minBody: 260,
                minCont: 260,
                min: 320,
                empty: 245,
              }"
              @row-click="onRowClick"
            />
          </div>
        </div>
      </div>
    </div>
    
  <DashboardTour />
  </div>
</template>
<script>
import ReportsBarChart from "@/examples/Charts/ReportsBarChart.vue";
import GradientLineChart from "@/examples/Charts/GradientLineChart.vue";
import MiniStatisticsCard from "@/examples/Cards/MiniStatisticsCard.vue";
import DefaultProjectCard from "./components/DefaultProjectCard.vue";
import PlaceHolderCard from "@/examples/Cards/PlaceHolderCard.vue";
import EventList from "@/views/components/eventList/table.vue";
import DashboardTour from "@/components/tour/DashboardTour.vue";
import api from '@/api/api';

export default {
  name: "dashboard-default",
  components: {
    MiniStatisticsCard,
    ReportsBarChart,
    GradientLineChart,
    DefaultProjectCard,
    PlaceHolderCard,
    EventList,
    DashboardTour,
  },
  data() {
    return {
      iconBackground: "bg-gradient-info",
      totalProduced: 0,
      totalShipped: 0,
      totalInTransit: 0,
      totalArrivedRetail: 0,
      dailyCounts: [],
      todayCount: 0,

      blCount: 0,
      rpCount: 0,
      rmCount: 0,
      pdCount: 0,
      chartKey: 0,
      chartData: {
        labels: [],
        datasets: []
      },
      sampleProductList:[],

      form: {
        category: '',
        eventTypes: [],
        actions: [],
        bizSteps: [],
        dispositions: [],
        timeFrom: '',
        timeTo: ''
      },
      applyTick: 0,
    };
  },
  mounted() {
    const mfId = this.$store.getters['UserStore/getMfId'];
    this.fetchDashboardData(mfId);
    this.applyTick++;
  },
  methods: {
    async fetchDashboardData(mfId) {
      try {
        const response = await api.get("/dashboard/list", {
          params: { mfId: mfId }
        });
        const result = response.data.result;

        this.totalProduced = result.totalProduced;
        this.totalShipped = result.totalShipped;
        this.totalInTransit = result.totalInTransit;
        this.totalArrivedRetail = result.totalArrivedRetail;

        this.dailyCounts = result.dailyCounts;
        this.todayCount = result.todayCount;

        this.blCount = result.blCount;
        this.rpCount = result.rpCount;
        this.rmCount = result.rmCount;
        this.pdCount = result.pdCount;

        this.chartData = result.chart;
        this.chartKey++;

        this.sampleProductList = result.sampleProductList;

      } catch (error) {
        console.error("통계 정보 불러오기 실패:", error);
      }
    },
    formatTitle(event) {
      return `(${event.locationName}) ${event.name} ${event.quantity}${event.unitName} ${event.eventStatus}`;
    },
    onRowClick(item) {
      const id = item?.eventID;
      if (!id) return;
      this.$router.push({ path: `/eventList/detail/${encodeURIComponent(id)}` });
    },
    toLocalInput(dt) {
      const tz = dt.getTimezoneOffset() * 60000;
      return new Date(dt.getTime() - tz).toISOString().slice(0, 16);
    },
    setDefaultLast7Days() {
      const now = new Date();
      const from = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
      this.form.timeFrom = this.toLocalInput(from);
      this.form.timeTo   = this.toLocalInput(now);
    },
  },
};
</script>
